<template src="./emailpreferences.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import Multiselect from "vue-multiselect";
  import Endpoints from "@/config/ApiEndpoints.js";

  export default {
    components: {
    Multiselect},
    filters: {
      date: function (data) {
        if (data == "" || data == null) {
          return "N/A";
        }
        var reqdString = "";
        for (let i = 0; i < 10; i++) {
          reqdString += data[i];
        }
        var arr = reqdString.split("-");
        reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
        return reqdString;
      },
    },
    data() {
      return {
        Templates: [],
        Users: [],
        submitted: false,
        Saving: false,
        SearchLoader: false,
        TemplateUserSelected:[]
      };
    },
    mounted() {
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );

      var AccountRoles = JSON.parse(localStorage.getItem("permissions"));
      if (
        !FleetSubscriptionModules["Notifications"] ||
        AccountRoles.fleet_role_id != 1
      ) {
        this.$router.push("/");
      }

      document.title = pbx_SiteTitle + " - Email Preferences";
      this.FleetSubscriptionModules = FleetSubscriptionModules;
      this.GetTemplates();
      this.GetUsers();
    },

    methods: {
      GetUsers() {
        var obj = {
          token: localStorage.getItem("token"),
          is_select: true
        };
        Axios.post(Endpoints.User.AllUser, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            var listData = Response.data.users;
            let usersArray = [{id: '0', name: 'All'}];
            listData.forEach(function (data) {
              usersArray.push({id: data.id, name: data.name});
            });
            this.Users = usersArray;
          }
        });
      },
      GetTemplates() {
        this.SearchLoader = true;
        var obj = {
          token: localStorage.getItem("token")
        };
        this.ShowLoader = true;
        Axios.post(Endpoints.EmailPreferences.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.SearchLoader = false;
            this.Templates = Response.data.notifications;
            let selectedData = [];
            this.Templates.forEach(function (data) {
              selectedData[data.id] = JSON.parse(data.user_ids);            
            });
            this.TemplateUserSelected = selectedData;
          }
        });
      },
      UpdateStatus(status, id){
        var obj = {
          token: localStorage.getItem("token"),
          status: status,
          id: id
        };
        Axios.post(Endpoints.EmailPreferences.StatusUpdate, obj).then((Response) => {
          if (Response?.data?.success == true) {
            this.GetTemplates();
            this.$swal.fire('Status Update Successfully.', '', 'success').then(() => {});
          } else {
            this.$swal.fire('Error in Update Status', '', 'error').then(() => {});
          }
        });
      },
      UpdateUser(id){
        var obj = {
          token: localStorage.getItem("token"),
          users: this.TemplateUserSelected[id],
          id: id
        };
        Axios.post(Endpoints.EmailPreferences.Update, obj).then((Response) => {
          if (Response?.data?.success == true) {
            this.GetTemplates();
            this.$swal.fire('Record Update Successfully.', '', 'success').then(() => {});
          } else {
            this.$swal.fire('Error in Update Status', '', 'error').then(() => {});
          }
        });
      }
    },
  };
</script>
<style scoped>
  .UsersBody td {
    padding-left: 15px !important;
  }
  .UsersBody .btn-primary {
    border: 1px solid transparent !important;
  }
  .table thead th,
  .table th,
  .table td {
    border: 0 !important;
  }
  .datatable-vue table tbody tr:nth-child(even) td:first-child{
    background-color: #FFF !important;
  }
  @media (min-width: 1280px) and (max-width: 1680px) {
    .actionBTN {
      width: 25%;
    }
  }
  @media (min-width: 780px) and (max-width: 1370px) {
    .actionBTN {
      min-width: 190px;
    }
  }
</style>
